import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import PageHero from "@/components/sections/PageHero";
import CTASection from "@/components/sections/CTASection";
import CampaignHeroVisual from "@/components/visuals/CampaignHeroVisual";
import { Reveal } from "@/components/motion/Reveal";
import { ArrowUpRight } from "lucide-react";
import { campaigns } from "@/content/campaigns";

export default function ForTradies() {
  return (
    <>
      <SEO
        title="For Tradies | Digital Growth Programs | Green Circle Group"
        description="Dedicated digital growth programs for roof restoration, heating and cooling, and NETCC approved solar and battery businesses."
        path="/for"
      />
      <PageHero
        eyebrow="For Tradies"
        heading="Programs shaped around the way your trade actually wins work."
        copy="Pick the program that fits your business. Each is built around how your customers really search, decide and buy—so more of the right work lands in your pipeline."
        breadcrumbs={[
          { label: "Home", to: "/" },
          { label: "For Tradies", to: "/for" },
        ]}
      />

      <section className="bg-soft py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="grid md:grid-cols-3 gap-6">
            {campaigns.map((c, i) => (
              <Reveal key={c.slug} delay={i * 0.06}>
                <Link
                  to={`/for/${c.slug}`}
                  data-testid={`for-tradies-card-${c.slug}`}
                  className="group flex flex-col h-full rounded-[1.75rem] overflow-hidden border border-border-neutral bg-white hover:border-mint transition-colors"
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    {c.heroImage ? (
                      <img
                        src={c.heroImage}
                        alt={c.heroAlt}
                        loading="lazy"
                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                    ) : (
                      <CampaignHeroVisual
                        iconName={c.icon}
                        accent={c.accent}
                        label={c.navLabel}
                        className="!aspect-[4/3] !rounded-none !border-0 !shadow-none"
                      />
                    )}
                  </div>
                  <div className="p-6 flex-1 flex flex-col">
                    <p className="text-xs font-bold uppercase tracking-[0.15em] text-mint">
                      For Tradies
                    </p>
                    <h2 className="mt-2 text-xl font-extrabold text-forest leading-snug">
                      {c.audience}
                    </h2>
                    <p className="mt-3 text-mid-neutral leading-relaxed text-sm flex-1">
                      {c.subheading}
                    </p>
                    <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-forest">
                      See the {c.navLabel} program
                      <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
